import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, post } from "../api";
import { API_URL } from "../api";

export interface ResolvedAccount {
  account_name: string;
  account_number: string;
}

interface Variables {
  account_number: string;
  bank_code: string;
}

function useResolveBankAccount(
  options?: MutationOptions<APIResponse<ResolvedAccount>, APIError, Variables>
) {
  const {
    isLoading: verifyingBankDetails,
    isError: isVerifyingBankDetailsError,
    error: verifyingBankDetailsError,
    mutate: verifyBankDetails,
  } = useMutation(async (variables: Variables) => {
    const res = await post(
      API_URL + "/account/user/account/name-enquiry",
      {
        AccountNumber: variables.account_number,
        BankCode: variables.bank_code,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    // Normalize Alert's PascalCase response
    const raw = res.data ?? {};
    const normalized: ResolvedAccount = {
      account_name: raw.AccountName ?? raw.Name ?? raw.account_name ?? "",
      account_number:
        raw.AccountNumber ?? raw.account_number ?? variables.account_number,
    };

    return { ...res, data: normalized };
  }, options);

  return {
    verifyBankDetails,
    isVerifyingBankDetailsError,
    verifyingBankDetailsError,
    verifyingBankDetails,
  };
}

export default useResolveBankAccount;
